
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface LenderRiskBadgeProps {
  risk: string | null;
}

export const LenderRiskBadge = ({ risk }: LenderRiskBadgeProps) => {
  const getRiskColor = (risk: string | null) => {
    switch (risk?.toLowerCase()) {
      case 'conservative':
        return 'bg-blue-100 text-blue-800';
      case 'moderate':
        return 'bg-yellow-100 text-yellow-800';
      case 'aggressive':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <Badge className={cn(
      "w-fit",
      getRiskColor(risk)
    )}>
      {risk || 'Risk Level N/A'}
    </Badge>
  );
};
